/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

//###############################################
// For creating new customers or communities
root.initNewOrgsPickers = () => $.each($('.new-political-org-picker'), function(index) {
  $(this).autocomplete({
    minLength: 3,
    delay: 300,
    source(request, response) {
      $.get('/suggestions/communities', {q: request.term}, response, "json");
    },
    select(event, ui) {
      updateNewCommunityForm(ui.item);
      clearGeoId();
      return false;
    },
    focus(event, ui) {
      updateNewCommunityForm(ui.item);
      clearGeoId();
      return false;
    }
  });

  return $(this).on('propertychange change click keyup input paste', function() {
    $('#existing-status').hide();
    const oldName = $('#community_request_name').data('name');
    const name = $('#community_request_name').val();
    if (name !== oldName) { resetCommunityRequestForm(); }
  });
});

root.updateNewCommunityForm = function(item) {
  const form = $('#new_account');
  const obj = $.parseJSON('{' + item.value + '}');
  if ((obj['account_id'] !== undefined) || (obj['geographic_area_id'] !== undefined)) {
    $('#account_name').val(item.label);
    $('#account_name').data('name', item.label);
    $('#account_id').val(obj['account_id']);
    $('#geographic_area_id').val(obj['geographic_area_id']);
    $('#account_geographic_area_id').val(obj['geographic_area_id']);
    $('#account_create_from_account_id').val(obj['account_id']);
    $('#political_org_id').val('');
    if (obj['account_id'] && ($("input[name='account[type]']:checked").val() === 'district') && !$('#create_from_account').length) {
      $('input[type="submit"]').prop('disabled', 'disabled');
      $('#existing-status').text('A community has already been created for this location.');
      $('#existing-status').show();
      form.prop('disabled', 'disabled');
      form.find('input[type="submit"]').prop('disabled', 'disabled');
    } else {
      $('#existing-status').text('');
      $('#existing-status').hide();
      form.prop('disabled', '');
      form.find('input[type="submit"]').prop('disabled', '');
    }
  } else {
    $('#existing-status').text('');
    $('#existing-status').hide();
    form.prop('disabled', '');
    form.find('input[type="submit"]').prop('disabled', '');
    $('#account_name').val(obj['address']);
    $('#account_name').data('name', obj['address']);
    $('#account_geographic_area_id').val('');
    $('#political_org_id').val('');
  }
};

root.clearGeoId = () => $(document).on('change', '#account_name', function() {
  const selectedName = $(this).data('name');
  const typedName = $(this).val();
  if (typedName !== selectedName) {
    return $('#account_geographic_area_id').val('');
  }
});

//###############################################
// For selecting existing communities
root.initCommunityRequestLinks = () => $('.community-request-link').click(function() {
  $('#request-communities').slideDown();
  scrollToElement($("#request-communities"));
  return false;
});

root.initOrgsPickers = () => $.each($('.political-org-picker'), function(index) {
  $(this).autocomplete({
    minLength: 3,
    delay: 300,
    source(request, response) {
      $.get('/suggestions/communities', {q: request.term}, response, 'json');
    },
    select(event, ui) {
      updateCommunityRequestForm(ui.item);
      return false;
    }
  });

  return $(this).on('propertychange change click keyup input paste', function() {
    $('#community-request-status .status').hide();
    const oldName = $('#community_request_name').data('name');
    const name = $('#community_request_name').val();
    if (name !== oldName) { resetCommunityRequestForm(); }
  });
});

root.updateCommunityRequestForm = function(item) {
  let $submit;
  const obj = $.parseJSON('{' + item.value + '}');
  if ((obj['account_id'] !== undefined) || (obj['geographic_area_id'] !== undefined)) {
    $('#community_request_name').val(item.label);
    $('#community_request_name').data('name', item.label);
    $('#community_request_account_id').val(obj['account_id']);
    $('#community_request_geographic_area_id').val(obj['geographic_area_id']);
    $('#political_org_id').val('');
    $('.community_request_state').hide();
    $('.community_request_type').hide();
    if ($('#my-communities').length) {
      $submit = $('.community-search-input input[type="submit"]');
      $submit.val($submit.data('submit-label') || 'Join');
    }

  } else {
    $('#community_request_name').val(obj['address']);
    $('#community_request_name').data('name', obj['address']);
    resetCommunityRequestForm(item);
    $('#community_request_state').val(obj['state']);
    $('#community_request_type').val(obj['type']);
    $submit = $('.community-search-input input[type="submit"]');
    $submit.val($submit.data('submit-label') || 'Request');
  }
};

root.resetCommunityRequestForm = function() {
  $('#community_request_account_id').val('');
  $('#political_org_id').val('');
  $('#community_request_state').val('');
  $('#community_request_type').val('');
  $('.community_request_state').show();
  $('.community_request_type').show();
  return $('#community-request-status .status').hide();
};

/*
$(function() {
  initCommunityRequestLinks();
  initOrgsPickers();
  return initNewOrgsPickers();
});
*/

function initCommunityPickersOnLoad() {
  if ($('.community-request-link').length) {
    initCommunityRequestLinks();
  }
  if ($('.political-org-picker').length) {
    initOrgsPickers();
  }
  if ($('.new-political-org-picker').length) {
    initNewOrgsPickers();
  }
}

$(initCommunityPickersOnLoad);
document.addEventListener('turbo:load', initCommunityPickersOnLoad);

